import { render } from "./FavoriteHotels.vue?vue&type=template&id=4b6eb5b0"
import script from "./FavoriteHotels.vue?vue&type=script&lang=js"
export * from "./FavoriteHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__